import React, { Component } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';

import './DoneItem.css';



export default class DoneItem extends Component {
  render() {
    return (
      <div className="mobile-done-item d-flex fadeAnimation">
        <div className="mobile-done-item__right d-flex">
          <FormControlLabel
            control={<Checkbox icon={<RadioButtonUncheckedIcon />} checkedIcon={<CheckCircleOutlineIcon />} name={this.props.event.title} checked onChange={(e) => { e.preventDefault(); this.props.deleteDone(this.props.event, this.props.event.id) }} />}
          />
          <div className="mobile-event-item__right--text d-flex flex-column">
            <h2>{this.props.event.title}</h2>
            <div>{this.props.event.description}</div>
          </div>
        </div>
      </div>
    );
  }
}